export const surplusTrimCompareMsg = [
  {
    title: '余料默认修边值设置',
    keys: [
      'trimmingMethod',
      'trimValue',
      'isCustomTrim',
      'topTrim',
      'bottomTrim',
      'leftTrim',
      'rightTrim',
    ],
  },
]

export const surplusTrimCompareTextMap = {
  trimmingMethod: '修边方式',
  trimValue: '修边值',
  isCustomTrim: '是否是自定义修边',
  topTrim: '上修边',
  bottomTrim: '下修边',
  leftTrim: '左修边',
  rightTrim: '右修边',
}

export const surplusTrimCompareValueMap = {
  trimmingMethod: {
    follow: '跟随原片中标准板材的修边值',
    custom: '单独设置修边值',
  },
  isCustomTrim: {
    true: '是',
    false: '否',
  },
}

export const surplusNoRollCompareMsg = [
  {
    title: '',
    keys: ['surplusNoRoll'],
  },
]

export const surplusNoRollCompareTextMap = {
  surplusNoRoll: '启用余料不翻版加工',
}

export const surplusNoRollCompareValueMap = {
  surplusNoRoll: {
    true: '开启',
    false: '关闭',
  },
}

export const isSecondConfirmCompareMsg = [
  {
    title: '',
    keys: ['isSecondConfirm'],
  },
]

export const isSecondConfirmCompareTextMap = {
  isSecondConfirm: '启用余料入库二次确认',
}

export const isSecondConfirmCompareValueMap = {
  isSecondConfirm: {
    true: '开启',
    false: '关闭',
  },
}
